export const SLIDE_ON_VISIBLE_EASING_DEFAULT = 'cubic-bezier(.75,1,.83,.67)'
export const SLIDE_ON_VISIBLE_DURATION_DEFAULT = 700
export const SLIDE_ON_VISIBLE_TIMEOUT_DEFAULT = 300
